export default __webpack_public_path__ + "static/media/camera.377539b8.png";